<rid-demo-page [title]="'Matrixlezen'" previousRoute="/mechanics">
  <rid-button class="w-full" content="Leeslijst | Geen tijd" variant="PRIMARY" routerLink="no-time" />
  <rid-button
    class="w-full"
    content="Leeslijst | Stopwatch"
    variant="PRIMARY"
    routerLink="stopwatch"
    [queryParams]="{ 'previous-duration': 3 }"
  />
  <div class="flex flex-col gap-2">
    <rid-button
      class="w-full"
      content="Leeslijst | Timer 2s"
      variant="PRIMARY"
      routerLink="timer"
      [queryParams]="{ duration: 2, 'previous-word-count': 10 }"
    />
    <rid-button
      class="w-full"
      content="Leeslijst | Timer 30s"
      variant="PRIMARY"
      routerLink="timer"
      [queryParams]="{ duration: 30, 'previous-word-count': 10 }"
    />
    <rid-button
      class="w-full"
      content="Leeslijst | Timer 60s"
      variant="PRIMARY"
      routerLink="timer"
      [queryParams]="{ duration: 60, 'previous-word-count': 10 }"
    />
  </div>
  <rid-button class="w-full" content="Matrix categoriseren" variant="PRIMARY" routerLink="categorise" />
</rid-demo-page>
